import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { useI18n } from '../i18n.js';

export function Layout({ children, onLogout }: { children: ReactNode; onLogout: () => void }) {
  const { t, toggle } = useI18n();

  const link = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : '');

  return (
    <div className="app">
      <header className="topbar">
        <div className="brand">
          MSC<span>{t('appName')}</span>
        </div>
        <nav className="nav">
          <NavLink to="/" end className={link}>
            {t('dashboard')}
          </NavLink>
          <NavLink to="/stock" className={link}>
            {t('stock')}
          </NavLink>
          <NavLink to="/sold" className={link}>
            {t('sold')}
          </NavLink>
          <NavLink to="/import" className={link}>
            {t('import')}
          </NavLink>
          <NavLink to="/imports" className={link}>
            {t('history')}
          </NavLink>
        </nav>
        <button type="button" className="btn small" onClick={toggle}>
          {t('language')}
        </button>
        <button type="button" className="btn small" onClick={onLogout}>
          {t('logout')}
        </button>
      </header>
      <main className="main">{children}</main>
    </div>
  );
}
